/** @graphql cc **/
import gql from 'graphql-tag';

export const ContentAnalyticsViewersUnifiedQuery = gql`
	query ContentAnalyticsViewersUnifiedQuery($contentId: ID!, $fromDate: String) {
		contentAnalyticsViewers(contentId: $contentId, fromDate: $fromDate) {
			count
		}
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				permissionType
			}
		}
	}
`;
